/* unplugin-vue-components disabled */import script from "./message.vue?vue&type=script&setup=true&lang=js"
export * from "./message.vue?vue&type=script&setup=true&lang=js"

import "./message.vue?vue&type=style&index=0&id=1f500180&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f500180"]])

export default __exports__